<template>
    <div class="entry-content">
        <img src="@/assets/icons/building-magnifying-glass-thin.svg" class="entry-content__icon"/>
        <div class="entry-content__intro">
            <text>{{intro}}</text>
        </div>
        <div class="entry-content__opts">
            <div class="form-button" @click="seek">
                发布需求
            </div>
            <div class="entry-content__number" @click="my">
                我的需求({{count}})
                <img src="@/assets/icons/chevron-right-sharp-light.svg" class="entry-content__number_icon"/>
            </div>
        </div>
    </div>
</template>

<script>
    import { countDemand } from '@/interface/modules/demand.api'

    export default {
        data () {
            return {
                intro: '根据你的需求匹配合适的房源，节省你找房时间。',
                count: 0
            }
        },
        mounted () {
            this.init()
        },
        methods: {
            init () {
                const that = this
                countDemand({
                    success: res => {
                        that.count = res.demand_count
                    }
                })
            },
            seek () {
                this.$router.push({name: 'demandSeek'})
            },
            my () {
                this.$router.push({name: 'demandList'})
            }
        }
    }
</script>


<style lang="less">
    .entry-content {
        padding: 30px;
        .entry-content__icon {
            width: 128px;
            height: 128px;
            margin: 0 auto;
            display: block;
        }
        .entry-content__intro {
            margin-top: 20px;
            font-size: 11pt;
            color: #666;
            padding: 0 15px;
        }
    }

    .entry-content__opts {
        padding: 0 15px;
        margin-top: 45px;
        .entry-content__number {
            margin-top: 15px;
            font-size: 10pt;
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: .75;
            .entry-content__number_icon {
                width: 14px;
                height: 14px;
            }
        }
    }
</style>

